import React, { lazy, Suspense } from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import ReactToolip from 'react-tooltip';
import { commaSeperatedAmount, CURRENCY_SYMBOL, scrollTo, selectedStyles } from '../../common';
import { imgBack, imgArrowUp, TYPES_OF_ZAKAT } from '../../common/images-svg';
import moment from 'moment';
import PageContext from '../../context';
import BannerHeader from '../banner/banner-header';
import { PayNow } from '../../jwt/_services/paynow-service';
import _, { isEqual } from 'lodash';
import i18n from "i18next";

import { connect } from 'react-redux';
import * as user from '../../redux/actions/userAction';
import * as zakat from '../../redux/actions/zakatActions';
import * as zakatCalc from '../../redux/actions/zakatCalcAction'
import { MAX_OXPAY_ACCEPTANCE_AMOUNT, config, APP_FLOW } from '../../common/constant';
import { Common } from '../../common/common';
import Loader from '../../views/MUIS/loader';
import PopupSwitchBusinessIndividual from '../../views/pop-up/popup-switch-business-individual';
import loginPool from '../../aws-pool/login-pool';
import { withTranslation } from "react-i18next";
import { MARK_EXCLAMATION_GREY_17x17 } from '../../common/images-s3';
import Footer from '../footer/footer.js';
import { enrollmentMethodHeaderData } from '../pay-zakat/type-of-zakat.js';

// enrollmentMethodHeaderData

const ImageLoader = lazy(() => import('../../common/image-loader'));

const Savings = lazy(() => import('./types/savings/savings'));
const Gold = lazy(() => import('./types/gold'));
const Insurance = lazy(() => import('./types/insurance/insurance'));
const Shares = lazy(() => import('./types/shares/shares.js'));
const Business = lazy(() => import('./types/business/index'));
const ZakatFitrah = lazy(() => import('./types/zakat-fitrah'));

let bodyWidth = 0;
let bodyHeight = 0;
let topPosition = 240;
let cCalculator = null;
let menuSection = null;
let btnScroll = null;
let winInnerHeight = 0;
let ttlPayable = null;
let options = null;
let businessIRAS = null;

class Calculator extends React.Component {
    _isMounted = false;

    static contextType = PageContext;

    constructor(props) {
        super(props);

        this.state = {
            types: [],
            leftTypes: [],
            totalAmount: parseFloat(this.props.zakatCalc.totalAmount) ?? 0,
            isActive: '',
            isBtnDisabled: false,
            IRASAutoInclusion: this.props.user.hasIRASInclusion,
            todaysNisabValue: this.props.homepage.muisZakatHarta?.nisab?.value ?? 0,
            attributes: this.props.homepage.muisZakatHarta?.attributes ?? [],
            fitrah: this.props.homepage.muisZakatFitrah ?? {},
            zakatId: this.props.homepage.muisZakatHarta?.id ?? 0,
            fitrahId: this.props.homepage.muisZakatFitrah?.id ?? 0,
            isFitrahEnabled: Common.isValidField(this.props.homepage.muisZakatFitrah) && this.props.user.isBusinessPayer !== true ? true : false,
            isLoading: false,
            isBusinessPayer: this.props.user.isBusinessPayer,
            isPopupSwitchBusinessIndividual: false,
            popupSwitchBusinessIndividual: {
                "title": 'calculator_switching_business',
            },
            sourceOfIncome: true,
            sourceOfIncomeList: [],
            sourceOfIncomeSelected: { 'label': 'Select source of income', 'value': 'Select source of income' },
        }

        this.setSources = this.setSources.bind(this);
        this.updateAmount = this.updateAmount.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.sourceOfIncomeUpdate = this.sourceOfIncomeUpdate.bind(this);
        this.setIRASAautoInclusion = this.setIRASAautoInclusion.bind(this);
        this.leftMenuScrollHandler = this.leftMenuScrollHandler.bind(this);
        this.toggleBusinessIndividual = this.toggleBusinessIndividual.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleSkip = this.handleSkip.bind(this);
    }

    toggleBusinessIndividual(isIndividualSelected) {
        const isBusinessPayer = this.state.isBusinessPayer;

        const {t} = this.props;

        this.setState({
            isPopupSwitchBusinessIndividual: true,
            popupSwitchBusinessIndividual: {
                "title": isIndividualSelected ? t('zakat_switch_business') : t('zakat_switch_individual'),
            },
        });
    }

    handleCloseBusinessIndividual = () => {
        this.setState({ isPopupSwitchBusinessIndividual: false });
    }

    handleOkayBusinessIndividual = () => {
        const isBusinessPayer = !this.state.isBusinessPayer;
        const IRASAutoInclusion = isBusinessPayer ? false : true;
        const isFitrahEnabled = Common.isValidField(this.props.homepage.muisZakatFitrah) && !isBusinessPayer;

        this.setState({ isBusinessPayer, IRASAutoInclusion, isFitrahEnabled }, () => {
            this.setSources();
        });

        this.props.dispatch(user.updateBusinessUser(isBusinessPayer));
        this.props.dispatch(user.updateIRASInclusion(IRASAutoInclusion));
        this.props.dispatch(zakatCalc.resetZakatCalcData());
        this.props.dispatch(zakatCalc.updateNisabValue(this.props?.homepage?.muisZakatHarta?.nisab?.value));

        // Reset Quick Zakat values as well, since it's causing incorrect behavior once use clicks on Back button
        this.props.dispatch(zakat.resetZakatData());
        if (!isBusinessPayer) {
            this.props.dispatch(user.updateBusinessUser(null));
        }

        this.setState({ isPopupSwitchBusinessIndividual: false });
    }

    getTypes(category) {
        let list = category.map(type => {
            let result = { label: type, value: type }
            return result;
        })
        return list;

    }

    handleSubmit() {
        this.props.dispatch(zakatCalc.submittingZakatCalcForm(true));
        this.props.dispatch(user.updatePaymentData({...this.props.user,iscalculatorFlow: true}));

        if (this.state.types.filter(item => item?.name.toLowerCase() === 'business')) {
            let topError = document.querySelectorAll('.invalid-feedback')[0];
            scrollTo(topError?.getBoundingClientRect().x);
        }

        const zakatHartaData = [
            this.props.zakatCalc.business,
            this.props.zakatCalc.gold,
            this.props.zakatCalc.insurance,
            this.props.zakatCalc.savings,
            this.props.zakatCalc.shares,
        ];
        let sourceList = zakatHartaData.filter((item) => {

            // Need to bind additional condition as Fitrah's Key:Value pairs are not same as Harta's
            if (item.name !== 'Zakat Fitrah') {
                if (this.props.user.hasIRASInclusion === true) {
                    if (parseFloat(item.amount) > 0 && item.isEligible) {
                        return item;
                    }
                } else {
                    if (this.props.user.isBusinessPayer && item.name === 'Business' && item.isEligible) {
                        return item;
                    } else if (parseFloat(item.amount) > 0 && item.isEligible) {
                        return item;
                    }
                }
            } else {
                if (parseFloat(item.amount) > 0 && item.isEligible) {
                    return item;
                }
            }

        })
        sourceList = sourceList.map((item) => {
            const modifiedItem = {
                name: item.name,
                amount: parseFloat(parseFloat(item.amount).toFixed(2)),
                remark: item.remark
            };

            const collectRemarks = (arr) => {
                if (!arr || !Array.isArray(arr)) {
                    return ''; // or any default value you prefer
                }

                return arr
                    .filter(obj => obj && obj.remark)
                    .map(obj => String(obj.remark).trim())
                    .filter(remark => remark) // Remove undefined or falsy values
            };
            const accountRemarks = collectRemarks(item.accounts);
            const policyRemarks = collectRemarks(item.policies);
            const portfoliosRemarks = collectRemarks(item.portfolios);

            if (accountRemarks) {
                modifiedItem.remark = accountRemarks;
            }

            if (policyRemarks) {
                modifiedItem.remark = policyRemarks;
            }

            if (portfoliosRemarks) {
                modifiedItem.remark = portfoliosRemarks;
            }

            return modifiedItem;
        });

        let fitrah = [this.props.zakatCalc.zakatfitrah.type.normal, this.props.zakatCalc.zakatfitrah.type.premium, this.props.zakatCalc.zakatfitrah.type.variable];
        let fitrahAmount = this.props.zakatCalc.zakatfitrah.amount ?? 0;

        if (fitrahAmount > 0) {
            fitrah = fitrah.filter((item) => {
                if (item.noOfPerson > 0 && item.amount > 0) {
                    item.name = item?.rate === this.props?.homepage?.muisZakatFitrah?.minAmount ? 'Normal'
                        : item?.rate === this.props?.homepage?.muisZakatFitrah?.maxAmount ? 'Premium'
                            : 'Variable';
                    return item;
                }
            });
        }

        // Store both array's destructured data in seperate file
        let muisHarta = [...sourceList]
        let muisFitrah = [...fitrah]

        let attributesObject = {};
        let appId = 0;

        if (sourceList.length > 0 && fitrahAmount > 0) {
            muisHarta = muisHarta.filter(item => item.name.trim() !== 'Zakat Fitrah');
            attributesObject = { muisHarta, muisFitrah }
            appId = this.state.zakatId;
        } else if (sourceList.length === 0 && fitrahAmount > 0) {
            attributesObject = { muisFitrah }
            appId = this.state.fitrahId;
        } else {
            muisHarta = muisHarta.filter(item => item.name.trim() !== 'Zakat Fitrah');
            attributesObject = { muisHarta }
            appId = this.state.zakatId;
        }

        this.setState({ isLoading: true });

        let payload = {
            "charityId": config.MUIS_CHARITY_ID, // Temporary will be fixed once all NGS Code is removed
            "amount": parseFloat(this.props.zakatCalc.totalAmount).toFixed(2),
            "currency": this.props.homepage.currencyCode ?? 'SGD',
            "hasIRASInclusion": this.props.user.hasIRASInclusion ?? false,
            "donationType": parseInt(appId),
            "isDeceased": this.props.user.isDeceased !== null ? this.props.user.isDeceased : false,
            "sourceOfIncome": this.props.user.isDeceased ? null : this.props.user.isBusinessPayer ? "Trade" : this.props.user.hasIRASInclusion ? this.props.zakatCalc.sourceOfIncome : null,
            "attribute": JSON.stringify(attributesObject),
            "timeZone": Intl.DateTimeFormat().resolvedOptions().timeZone,
            "transactionNumber": this.props.user.transactionNo ?? null,
        }
        console.log(payload, 'payloadd')

        if (!(this.props?.zakatCalc?.business?.hasErrors ?? false)) {
            this.setState({ isBtnDisabled: false, isLoading: false })
            this.props.setHeaderData(enrollmentMethodHeaderData)
            this.props.dispatch(user.updateUserSteps(enrollmentMethodHeaderData));
        } else {
            this.setState({ isBtnDisabled: false, isLoading: false });
        }
        setTimeout(() => {
            this.props.dispatch(zakatCalc.submittingZakatCalcForm(false));
        }, 0);
    }

    updateAmount(state) {
        const sharesAmount = parseFloat(state.shares.amount).toFixed(2);
        const savingsAmount = parseFloat(state.savings.amount).toFixed(2);
        const goldAmount = parseFloat(state.gold.amount).toFixed(2);
        const insuranceAmount = parseFloat(state.insurance.amount).toFixed(2);
        const fitrahAmount = parseFloat(state.zakatfitrah.amount).toFixed(2);
        const businessAmount = parseFloat(state.business.amount).toFixed(2);

        let totalAmount = parseFloat(sharesAmount)
            + parseFloat(savingsAmount)
            + parseFloat(goldAmount)
            + parseFloat(insuranceAmount)
            + parseFloat(fitrahAmount)
            + parseFloat(businessAmount);

        totalAmount = parseFloat(parseFloat(totalAmount).toFixed(10));

        this.setState({ totalAmount })
        this.props.dispatch(zakatCalc.updateTotal(totalAmount));
    }

    focusedHandler = (_type, source, index) => {
        const { t } = this.props;
        let type = _type;

        // if (Common.isValidField(this.props.history.location.state?.typesInEn)) {
        //     type = this.props.history.location.state.typesInEn;
        // }

        if (type && type !== 'body') {
            if (type && source) {
                this.setState({ isActive: type }, () => {
                    let ele = document.querySelector('#' + type?.replace(/\s+/gi, '-'));
                    //scrollTo(ele.offsetTop + 70);
                    scrollTo(cCalculator.offsetTop + 1);
                    //document.body.scrollTop = ele?.offsetTop ? ele.offsetTop + 70 : 0;
                    ttlPayable = document.querySelector('.c-calculator .c-ttl-payable');

                    if (this.state.types[this.state.types.length - 1]?.name === type && this.state.types.length > 1) {
                        ttlPayable?.classList.add('hide-line');
                    } else {
                        ttlPayable?.classList.remove('hide-line');
                    }
                });
            } else if (type && type != this.state.isActive) {
                this.setState({ isActive: type }, () => {
                    let ele = document.querySelector('#' + type.replace(/\s+/gi, '-'));
                    if (this.state.types[this.state.types.length - 1].name === type) {
                        ttlPayable?.classList.add('hide-line');
                    } else {
                        ttlPayable?.classList.remove('hide-line');
                    }
                });
            }
        } else {
            document.body.scrollTop = 0;
        }
    }

    setIRASAautoInclusion() {
        this.setState({ IRASAutoInclusion: !this.state.IRASAutoInclusion }, () => {
            !this.state.IRASAutoInclusion && this.props.dispatch(zakatCalc.updateSourceOfIncome(null));
            this.props.dispatch(user.updateIRASInclusion(!this.props.user.hasIRASInclusion));
            // this.props.dispatch(user.resetUserFormData());
            // Only clear enrolment form data if user is not logged in
            if (!Boolean(loginPool.getCurrentUser())) {
                this.props.dispatch(user.resetUserFormData());
            }
        })

    }

    leftMenuScrollHandler(e) {
        bodyHeight = document.body.scrollHeight;
        let bodyScrollTop = document.body.scrollTop;
        let difference = bodyHeight - bodyScrollTop;

        winInnerHeight = window.innerHeight;
        options = document.querySelector('.c-calculator .sec-block-calc');

        if (bodyScrollTop > topPosition) {
            //if (difference > winInnerHeight + 180) {
            if ((bodyScrollTop + menuSection.clientHeight - topPosition) < (options.clientHeight /* + businessIRAS?.clientHeight */)) {
                menuSection.style.top = document.body.scrollTop - topPosition + 'px';
                menuSection.classList.remove('pos-btm');
                btnScroll.style.display = 'block';
                if (bodyWidth >= 1295) {
                    btnScroll.style.bottom = '40px';
                } else if (bodyWidth >= 768) {
                    btnScroll.style.bottom = '40px';
                }
            } else {
                menuSection.classList.add('pos-btm');
                if (bodyWidth >= 1295) {
                    btnScroll.style.bottom = (265 + (winInnerHeight - difference)) + 'px';
                } else if (bodyWidth >= 768) {
                    btnScroll.style.bottom = (265 + (winInnerHeight - difference)) + 'px';
                }
            }
        } else {
            menuSection.classList.remove('pos-btm');
            btnScroll.style.display = 'none';
        }

    }

    componentDidMount() {

        document.body.addEventListener('scroll', this.leftMenuScrollHandler);

        this._isMounted = true;

        this.props.dispatch(zakatCalc.updateNisabValue(this.props?.homepage?.muisZakatHarta?.nisab?.value));

        // sessionStorage.setItem("flowType", APP_FLOW.ZAKAT);

        cCalculator = document.querySelector('.c-calculator');
        menuSection = document.querySelector('.c-calculator .c-zakat-types');
        btnScroll = document.querySelector('.c-calculator .btn-scroll-up');
        options = document.querySelector('.c-calculator .sec-block-calc');
        businessIRAS = document.querySelector('.c-calculator .c-business-iras');
        bodyWidth = document.body.clientWidth;

        this._isMounted = true;

        this.setSources();

        i18n.on("languageChanged", () => {

            const { t } = this.props;

            let sourceOfIncomeList = this.props.homepage.muisZakatHarta?.sourceOfIncomes ?? [];

            sourceOfIncomeList = sourceOfIncomeList.map((item) => this.sourceOfIncomeUpdate(item));

            sourceOfIncomeList = this.getTypes(sourceOfIncomeList);

            this.setState({
                sourceOfIncomeList: this.props.user.isBusinessPayer ? [{ label: t('Trade_label'), value: t('Trade_label') }] : sourceOfIncomeList,
            });

        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(prevProps.zakatCalc, this.props.zakatCalc)) {
            const userData = {
                ...this.props.user,
                isAmountChanged: true,
            }
            this.props.dispatch(user.updatePaymentData(userData));
        }
    }

    componentWillUnmount() {
        // Required to avoid Memory Leak of state when unmounting
        this._isMounted = false;

        document.body.removeEventListener('scroll', this.leftMenuScrollHandler);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.zakatCalc.totalAmount !== this.props.zakatCalc.totalAmount) {
            this.setState({ totalAmount: parseFloat(newProps.zakatCalc.totalAmount).toFixed(2) })
        }

        if (_.isEqual(newProps.zakatCalc, this.props.zakatCalc) === false) {
            this.updateAmount(newProps.zakatCalc);
        }
    }

    setSources = () => {
        let sourceOfIncomes = this.props.homepage.muisZakatHarta?.sourceOfIncomes ?? [];
        let scrollType = undefined;

        // sourceOfIncomes = this.getTypes(sourceOfIncomes);

        if (this.props.zakatCalc.sourceOfIncome === null && !this.props.user.isBusinessPayer) {
            this.props.dispatch(zakatCalc.updateSourceOfIncome(sourceOfIncomes[0] ?? null));
        } else if (this.state.isBusinessPayer) {
            this.props.dispatch(zakatCalc.updateSourceOfIncome("Trade"));
        }

        const zakatCalculatorArray = this.state.isBusinessPayer ? [{
            img: '',
            name: 'Business',
            amt: parseFloat(this.props.zakatCalc.business.amount),
        }] : [{
            img: '',
            name: 'Savings',
            amt: parseFloat(this.props.zakatCalc.savings.amount).toFixed(2),
        },
        {
            img: '',
            name: 'Gold',
            amt: parseFloat(this.props.zakatCalc.gold.amount),
        },
        {
            img: '',
            name: 'Insurance',
            amt: parseFloat(this.props.zakatCalc.insurance.amount),

        },
        {
            img: '',
            name: 'Shares',
            amt: parseFloat(this.props.zakatCalc.shares.amount),
        },
        ];

        sourceOfIncomes = sourceOfIncomes.map((item) => this.sourceOfIncomeUpdate(item));

        sourceOfIncomes = this.getTypes(sourceOfIncomes);

        this.setState({
            types: zakatCalculatorArray,
            sourceOfIncomeList: this.state.isBusinessPayer ? [{ label: 'Trade', value: 'Trade' }] : sourceOfIncomes,
        }, () => this.state.isFitrahEnabled && this.setState({ types: [...this.state.types, { img: '', name: 'Zakat Fitrah', amt: parseFloat(this.props.zakatCalc.zakatfitrah.amount) }] }));


        // scrollType = this.props.history.location.state?.type; // || types?.[0].name;

        // if (scrollType) {
        //     this.setState({ isActive: scrollType },
        //         () => { setTimeout(() => this.focusedHandler(scrollType, 'scroll'), 200) }
        //     );
        // } else
        if (this.state.isBusinessPayer) {
            setTimeout(() => this.focusedHandler("Business", 'scroll'), 200);
        } else {
            setTimeout(() => {
                this.focusedHandler(zakatCalculatorArray[0]?.name, 'scroll');
                //scrollTo();
            }, 200,);
        }
    }

    sourceOfIncomeUpdate(value) {

        const { t } = this.props

        // eslint-disable-next-line default-case
        switch (true) {

            case String(value).includes('Employment'):
                return t('Source_of_income_employment');

            case String(value).includes('Others'):
                return t('Source_of_income_others');

            case String(value).includes('Dividend'):
                return t('Source_of_income_dividend');

            case String(value).includes('Rental'):
                return t('Source_of_income_rental');

            case String(value).includes('Trade'):
                return t('Trade_label');

            case String(value).includes('Interest'):
                return t('Source_of_income_interest');
        }
    }

    getTranslatedName(value) {
        const { t } = this.props

        // eslint-disable-next-line default-case
        switch (true) {

            case String(value).includes('Savings'):
                return t('Savings_label');

            case String(value).includes('Gold'):
                return t('Gold_label');

            case String(value).includes('Insurance'):
                return t('Insurance_label');

            case String(value).includes('Shares'):
                return t('Shares_label');

            case String(value).includes('Fitrah'):
                return t('Zakat_fitrah_label');

            case String(value).includes('Business'):
                return t('Business_label');
        }
    }

    handleNext() {
        this.handleSubmit()

    }

    handleSkip() {

    }

    render() {

        const { t } = this.props
        const types = this.props.user.isDeceased ? this.state.types.filter((item) => item.name.toLowerCase() !== 'zakat fitrah') : this.state.types;

        let currentSOI = this.props.zakatCalc.sourceOfIncome;

        switch (true) {
            case this.props.zakatCalc.sourceOfIncome === 'Pekerjaan' || this.props.zakatCalc.sourceOfIncome === 'Employment':
                currentSOI = t('Source_of_income_employment');
                break;

            case this.props.zakatCalc.sourceOfIncome === 'Dividend' || this.props.zakatCalc.sourceOfIncome === 'Dividen':
                currentSOI = t('Source_of_income_dividend');
                break;

            case this.props.zakatCalc.sourceOfIncome === 'Rental' || this.props.zakatCalc.sourceOfIncome === 'Sewa':
                currentSOI = t('Source_of_income_rental');
                break;

            case this.props.zakatCalc.sourceOfIncome === 'Others' || this.props.zakatCalc.sourceOfIncome === 'Yang lain':
                currentSOI = t('Source_of_income_others');
                break;

            case this.props.zakatCalc.sourceOfIncome === 'Interest' || this.props.zakatCalc.sourceOfIncome === 'Kadar faedah':
                currentSOI = t('Source_of_income_interest');
                break;

            case this.props.zakatCalc.sourceOfIncome === 'Trade' || this.props.zakatCalc.sourceOfIncome === 'Perdagangan':
                currentSOI = t('Trade_label');
                break;

            default:
                break;
        }

        return (
            <>
                <div className='flow-view'>
                    <div className='c-all-nisab-value'>
                        <p>
                            {t('Home_nisab_month_text')} :{' '} <span> {commaSeperatedAmount(CURRENCY_SYMBOL, this.props?.homepage?.muisZakatHarta?.nisab?.value ?? 0)} ({moment().format('MMMM') + ' ' + moment().format('YYYY')}) </span>
                        </p>
                    </div>
                    <div className={'landing-page c-calc-page ' + (this.props.homepage.lang ? this.props.homepage.lang : '')}>
                        <div className='sec-container'>
                            <div className='c-calculator'>
                                {/* <div className='c-heading'>
                            <div className='c-arrow-title'>
                                <button onClick={() => this.props.history.push('/')} className='btn btn-light btn-back'>
                                    {imgBack}
                                </button>
                                <span className='c-back'>{t('back')}</span>
                            </div>
                            <div className='c-title'>{t('Zakat_calculator')}</div>
                            <div className='c-all-nisab-value'>
                                <p>{t('Home_nisab_month_text')} : <b>{commaSeperatedAmount(CURRENCY_SYMBOL, this.state.todaysNisabValue)} ({moment().format('MMMM') + ' ' + moment().format('YYYY')})</b></p>
                                <a href="https://zakat.sg/current-past-nisab-values/" target="_blank" rel="noreferrer">{t('Home_nisab_view_all_text')}</a>
                            </div>
                        </div> */}
                                <div className={'c-body ' + (Boolean(this.state.isBusinessPayer) ? 'business-payer ' : '')}>
                                    <div className='c-business-iras' style={{ 'overflow': 'visible' }}>
                                        {!this.props.user.isDeceased && !this.props.user.isOthers ?
                                            <div className='c-business-individual' onClick={() => {

                                                const isIndividualSelected = document.getElementById('individual-label').classList.contains('selected');
                                                this.toggleBusinessIndividual(isIndividualSelected)
                                            }}>
                                                <div className='c-cus-slider'>
                                                    <button
                                                        type='button'
                                                        className='btn c-slider'>
                                                        <span id='individual-label' className={'lbl-individual ' + (this.state.isBusinessPayer ? '' : 'selected')}>{t('Individual_label')}</span>
                                                        <span className={'lbl-business ' + (this.state.isBusinessPayer ? 'selected' : '')}>{t('Business_label')}</span>
                                                    </button>
                                                </div>
                                            </div> : null
                                        }
                                        {/* {!this.props.user.isBusinessPayer && !this.props.user.isDeceased ?
                                            <div className='c-iras-auto-inclusion'>
                                                <div className='c-iras-tooltip'>
                                                    <div className='c-img' data-tip={t('Zakat_tooltip')} data-for='iras-tooltip' data-arrow-color='#47545b'>
                                                        <Suspense fallback={null}>
                                                            <ImageLoader type="image" src={MARK_EXCLAMATION_GREY_17x17} ></ImageLoader>
                                                        </Suspense>
                                                    </div>
                                                    <h4>{t('IRAS_auto_inc_text')}</h4>
                                                    <ReactToolip id='iras-tooltip' effect={'solid'} html={true} className='c-tooltip'></ReactToolip>
                                                </div>
                                                <div className='c-cus-slider'>
                                                    <button type='button' className={'c-slider ' + (this.state.IRASAutoInclusion ? 'selected' : '')} onClick={this.setIRASAautoInclusion}>
                                                        <div className='circle'></div>
                                                    </button>
                                                </div>
                                            </div> : null
                                        } */}
                                        {(this.props.user.hasIRASInclusion || this.props.user.isBusinessPayer) &&
                                            <form className='form c-source-of-income'>
                                                <Select
                                                    name="sourceOfType"
                                                    id="sourceOfType"
                                                    styles={selectedStyles}
                                                    placeholder={this.state.sourceOfIncomeList[0]?.value}
                                                    className={'select-form-control ' + (this.state.sourceOfIncomeSelected?.['value'].trim() !== this.state.sourceOfIncomeList[0]?.value ? 'selected ' : '') + (Boolean(this.props.user.isBusinessPayer) ? 'disabled ' : '')}
                                                    value={Boolean(currentSOI) ? { label: `${currentSOI}`, value: currentSOI } : ''}
                                                    options={this.state.sourceOfIncomeList}
                                                    isDisabled={Boolean(this.props.user.isBusinessPayer)}
                                                    isSearchable={false}
                                                    onChange={(e) => this.props.dispatch(zakatCalc.updateSourceOfIncome(e.value))}
                                                />
                                            </form>
                                        }
                                    </div>

                                    <div className='c-zakat-types'>
                                        <ul>
                                            {types && types.length > 0 ?
                                                types.map((type, index) =>
                                                    <li key={index} className={type.name === this.state.isActive ? 'active' : ''}>
                                                        <div
                                                            className="g-row"
                                                            onClick={() => setTimeout(() => this.focusedHandler(type.name, "scroll", index), 200)}
                                                            role="button"
                                                            tabIndex={0}
                                                            onKeyPress={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    setTimeout(() => this.focusedHandler(type.name, "scroll", index), 200);
                                                                }
                                                            }}
                                                        >
                                                            <div className="c-img-name">
                                                                <div className="c-type-zakat">{this.getTranslatedName(type.name)}</div>
                                                            </div>
                                                            <div className="c-amt">
                                                                <span className="amt" id={`type-${type.name}`}>
                                                                    {Common.intlNumberFormat(type.amt)}
                                                                </span>
                                                            </div>
                                                            <div className="btm-line"></div>
</div>
                                                    </li>
                                                )
                                                : null
                                            }
                                        </ul>
                                        {this.state.types.length > 0 ?
                                            <ul className='c-ttl-payable'>
                                                <li>
                                                    <div className='g-row'>
                                                        <div className='c-img-name'>
                                                            &nbsp;
                                                        </div>
                                                        {/* <div className='c-ttl-amt'>
                                                    <p>{t('Total_payable_zakat_label')} </p>
                                                    <span className='amt'>
                                                        {Common.intlNumberFormat(this.state.totalAmount)}
                                                    </span>
                                                </div> */}
                                                        <div className='btm-line'></div>
                                                    </div>
                                                </li>
                                            </ul>
                                            : null
                                        }
                                    </div>

                                    <div className='sec-block-calc'>
                                        {this.state.types.length > 0 ?
                                            // eslint-disable-next-line array-callback-return
                                            this.state.types.map((type, index) => {
                                                switch (type.name.toLowerCase()) {
                                                    case 'savings':
                                                        return <Suspense fallback={null} key={index}><Savings name={type.name} sourceOfIncome={type.sourceOfIncome} isActive={this.state.isActive} updateAmount={this.updateAmount} onFocus={this.focusedHandler} /></Suspense>
                                                    case 'gold':
                                                        return <Suspense fallback={null} key={index}><Gold name={type.name} sourceOfIncome={type.sourceOfIncome} isActive={this.state.isActive} updateAmount={this.updateAmount} onFocus={this.focusedHandler} /></Suspense>
                                                    case 'insurance':
                                                        return <Suspense fallback={null} key={index}><Insurance name={type.name} sourceOfIncome={type.sourceOfIncome} isActive={this.state.isActive} onFocus={this.focusedHandler} /></Suspense>
                                                    case 'shares':
                                                        return <Suspense fallback={null} key={index}><Shares name={type.name} sourceOfIncome={type.sourceOfIncome} isActive={this.state.isActive} onFocus={this.focusedHandler} /></Suspense>
                                                    case 'business':
                                                        return <Suspense fallback={null} key={index}><Business name={type.name} sourceOfIncome={type.sourceOfIncome} isActive={this.state.isActive} updateAmount={this.updateAmount} onFocus={this.focusedHandler} /></Suspense>
                                                    case 'zakat fitrah':
                                                        if (this.state.isFitrahEnabled) {
                                                            return <Suspense fallback={null} key={index}><ZakatFitrah name={type.name} sourceOfIncome={type.sourceOfIncome} isActive={this.state.isActive} fitrahData={this.state.fitrah} updateAmount={this.updateAmount} onFocus={this.focusedHandler} /></Suspense>
                                                        } else {
                                                            return null;
                                                        }
                                                    default:
                                                        break;
                                                }
                                            })
                                            : null
                                        }
                                            {(this.state.totalAmount > MAX_OXPAY_ACCEPTANCE_AMOUNT) ? <div className="invalid-feedback error">{`${t('Errors_total_amount')} $${MAX_OXPAY_ACCEPTANCE_AMOUNT}`}</div> : null}

                                        <div className='calc-footer'>
                                            {/* <div className='c-pay-now'>
                                                <div className='c-top'>
                                                    <div className='c-payable'>
                                                        <p className='title'>{t('Total_payable_zakat_label')}</p>
                                                        <p className='amt'>{Common.intlNumberFormat(this.state.totalAmount)}</p>
                                                    </div>
                                                    <div className='c-btn-note'>
                                                        <button
                                                            type='submit'
                                                            className='btn btn-dark btn-pay-now'
                                                            id='makepayment'
                                                            disabled={
                                                                this.state.totalAmount > 0.00 && this.state.totalAmount <= MAX_OXPAY_ACCEPTANCE_AMOUNT
                                                                    && this.state.isBtnDisabled === false ? false : true
                                                            }
                                                            onClick={this.handleSubmit}
                                                        >{t('Make_payment_label')}</button>
                                                        {this.props.user.isOthers ? this.props.user.isDeceased ? <span className={'note ' + (Boolean(this.props.user.isDeceased) ? 'deceased ' : '')}>*{t('zakat-lable4')}</span> : <span className='note'>{t('zakat-lable5')}</span> : null}
                                                    </div>
                                                </div>
                                            </div> */}
                                            <Footer isSkipButtonVisible={false} handleNext={this.handleNext} handleSkip={this.handleSkip} disabled={
                                                this.state.totalAmount > 0.00 && this.state.totalAmount <= MAX_OXPAY_ACCEPTANCE_AMOUNT
                                                    && this.state.isBtnDisabled === false ? false : true
                                            } totalPayable={this.state.totalAmount} />
                                        </div>
                                    </div>
                                    <button type='button' className='btn btn-dark btn-scroll-up' onClick={() => this.focusedHandler('body', 'scroll')}>{imgArrowUp}</button>
                                </div>
                                {
                                    this.state.isPopupSwitchBusinessIndividual ?
                                        <PopupSwitchBusinessIndividual data={this.state.popupSwitchBusinessIndividual} handleClose={this.handleCloseBusinessIndividual} handleOkay={this.handleOkayBusinessIndividual} />
                                        : null
                                }
                                {this.state.isLoading ?
                                    <div className='c-loader'><Loader /></div> : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}


function mapStateToProps(state) {
    return {
        user: state.userReducer,
        zakatCalc: state.zakatCalcReducer,
        homepage: state.homepageReducer
    }
}

export default connect(mapStateToProps)(withTranslation()(Calculator))